import type * as React from 'react'
import { Archive, ChevronDown, Eraser } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

/**
 * Archive and Erase are infrequent, so they sit under a "More" menu in the profile
 * header and leave the primary action alone. Erase is irreversible: last, in
 * destructive text; its confirmation dialog carries the only red fill.
 */
export function ProfileLifecycleActions({
  triggerRef,
  canArchive,
  canErase,
  pending,
  onArchive,
  onErase,
}: {
  triggerRef?: React.Ref<HTMLButtonElement>
  canArchive: boolean
  canErase: boolean
  pending: boolean
  onArchive: () => void
  onErase: () => void
}) {
  if (!canArchive && !canErase) return null

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button ref={triggerRef} type="button" variant="outline">
          More
          <ChevronDown className="ml-1.5 size-4" strokeWidth={1.5} aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-40">
        {canArchive && (
          <DropdownMenuItem disabled={pending} onSelect={onArchive}>
            <Archive className="mr-2 size-4" strokeWidth={1.5} aria-hidden="true" />
            Archive
          </DropdownMenuItem>
        )}
        {canErase && (
          <DropdownMenuItem destructive disabled={pending} onSelect={onErase}>
            <Eraser className="mr-2 size-4" strokeWidth={1.5} aria-hidden="true" />
            Erase…
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
